
import React, { useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useMounted from '../../hooks/useMounted';


import SimpleReactValidator from 'simple-react-validator';
import { post } from '../../helpers/api_helper';
import { POST_GET_SIZE_DETAIL, POST_ADD_EDIT_SIZE, POST_GET_SIZE_FORM_OPTION } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';

const Item = (props) => {
    const navigate = useNavigate();

    const [isLoader, setLoader] = useState(0);

    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ sizeId: 0, itemId: '', sizeName: '' });
    const [ItemList, setItemList] = useState([]);
    const [, forceUpdate] = useState();

    const { id } = useParams()

    useMounted(() => {
        async function get_detaile() {
            var res_data = await post(POST_GET_SIZE_FORM_OPTION, { });
            if (res_data.status) {
                setItemList(res_data.data.items_list);
            }
            if (id) {
                var res_data1 = await post(POST_GET_SIZE_DETAIL, { 'id': id });
                if (res_data1.status) {
                    setInputs(res_data1.data.sizeDetail);
                } else {
                    toast.error(res_data1.message);
                    navigate("/");
                }
            }
            setLoader(1)
        }
        get_detaile();
    }, [])

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_EDIT_SIZE, form_inputs);
            if (res_data.status) {
                toast(res_data.message);
                navigate("/size");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
    }



    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <div className='row'>
                <div className="col-md-6">
                    <div className="card mb-4">
                        <h5 className="card-header">Size</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Select Item</label>
                                    <select name="itemId" value={form_inputs.itemId} onChange={handleInputChange} className="form-control" >
                                        <option value="">Select Item</option>
                                        {ItemList && ItemList.map(({ itemId, itemName }) => (
                                            <option key={itemId} value={itemId}>
                                                {itemName}
                                            </option>
                                        ))}
                                    </select>
                                    {simpleValidator.current.message('item', form_inputs.itemId, 'required')}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Size Name *</label>
                                    <input name="sizeName" value={form_inputs.sizeName} onChange={handleInputChange} className="form-control" placeholder="Enter Size Name" type="text" />
                                    {simpleValidator.current.message('size name', form_inputs.sizeName, 'required')}
                                </div>

                                <div className='text-center'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Save
                                    </button>
                                    <Link to="/size" className="btn btn-danger ms-3"> Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Item;